import * as dealSettingApi from "src/api/deal-setting";
import { isEmpty } from "src/assets/scripts/utilities/helpers";

export function useDealSettingsExist() {
  const dealSetting = ref(null);
  const dealSettingExist = ref(true);
  const isFetchingDealSetting = ref(false);

  const fetchDealSettings = async ({ buyerId, sellerId }) => {
    try {
      if (!buyerId || !sellerId) {
        return;
      }

      dealSetting.value = null;

      isFetchingDealSetting.value = true;

      const dealSettingResponse = await dealSettingApi.get({
        buyer_id: buyerId,
        seller_id: sellerId,
        is_active: 1,
      });

      dealSetting.value = dealSettingResponse?.data?.data;

      if (isEmpty(dealSetting.value)) {
        dealSettingExist.value = false;
      } else {
        dealSettingExist.value = true;
      }

      isFetchingDealSetting.value = false;
    } catch (error) {
      isFetchingDealSetting.value = false;

      console.error(error);
    }
  };

  return {
    dealSetting,
    dealSettingExist,
    fetchDealSettings,
  };
}
